module.exports = __webpack_public_path__ + "static/media/banner_420x230_6.1cdd1ac6.jpg";